import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const submitContact = (data) => apiClient.post("/contact", data);
export const joinWaitlist = (data) => apiClient.post("/waitlist", data);
